const colors = {
  black: "#000000",
  white: "#FFFFFF",
  greenPrimary: "#37bf3a",
  accent: "#ff0066"
};

export default colors;